import classNames from "classnames";
import { useMediaQuery } from "react-responsive";

import { PolicyHeader } from "components/page-header/policy-header";
import { HeaderLogo } from "components/shared/logo-link";
import { screenSizes } from "consts";
import { useFlags } from "utils";

import styles from "./desktop-header.module.scss";
import { Navigation } from "./navigation";
import { ProfileDropdown } from "./profile-dropdown";

type DesktopHeaderProps = {
  hideNavigation?: boolean;
  hidePolicyHeader?: boolean;
  tabs?: Record<string, string>[];
  pageTitle: string;
};

export const DesktopHeader = ({
  hideNavigation,
  hidePolicyHeader,
  tabs,
  pageTitle,
}: DesktopHeaderProps) => {
  const isLaptop = useMediaQuery({
    maxWidth: screenSizes.laptopL,
    minWidth: screenSizes.laptop,
  });
  const { policyPage: isPolicyPageEnabled } = useFlags();

  return (
    <div className={styles.headerContainer}>
      <div
        className={classNames(
          styles.primaryHeader,
          isPolicyPageEnabled && styles.primaryHeaderWithoutPolicySelector,
        )}
        data-testid="primary-header"
      >
        <div className={styles.logoWrapper}>
          <HeaderLogo logo={isLaptop ? "icon" : "default"} />
        </div>
        <div className={styles.rightSection}>
          {!hideNavigation ? (
            <div className={styles.mainNavigation}>
              <Navigation />
            </div>
          ) : null}
          {!hideNavigation ? <div className={styles.divider} /> : null}
          <div className={styles.profileDropdown}>
            <ProfileDropdown />
          </div>
        </div>
      </div>
      {!hidePolicyHeader && <PolicyHeader tabs={tabs} pageTitle={pageTitle} />}
    </div>
  );
};
